import { createTheme } from '@mui/material/styles';

import { breakpoints } from './breakpoints';
import { components } from './components';
import { createAppPalette } from './palette';
import { shadows } from './shadows';
import { spacing } from './spacing';
import { ThemeName } from './tokens';
import { typography } from './typography';

import './tokens.css';
import './hauser.css';

export const createAppTheme = (themeName: ThemeName) =>
  createTheme({
    breakpoints,
    components,
    palette: createAppPalette(themeName),
    shadows,
    spacing,
    typography,
  });

export { MODE_LABELS, MODE_THEME, MODES, THEME_LABELS, THEME_NAMES, TOOLS_THEME, tx } from './tokens';
export type { Mode } from './tokens';
export type { ThemeName };
